import { classnames, fCredit } from '@aibees/shared/utils';
import { Stack, Typography } from '@mui/material';
import { memo } from 'react';
import { usePlanCardContext } from '../../context';
import type { PlanPriceProps as Props } from './types';

export const PlanPrice = memo(({ className }: Props) => {
  const { isPaid, selectedPlan, yearly, isCompact, isMostPopular } =
    usePlanCardContext();
  const amount = isPaid ? fCredit(selectedPlan?.amount || 0) : '0';
  const periodLabel = yearly && isPaid ? 'Year' : 'Month';

  const priceColor =
    isCompact && isMostPopular
      ? 'common.white'
      : isCompact
      ? 'grey.900'
      : isMostPopular
      ? 'common.white'
      : 'grey.900';

  const periodColor =
    isCompact && isMostPopular
      ? 'common.white'
      : isCompact
      ? 'grey.600'
      : isMostPopular
      ? 'common.white'
      : 'grey.600';

  return (
    <Stack
      className={classnames('PlanPrice', className)}
      direction="row"
      alignItems="baseline"
      gap={1}
    >
      <Typography
        variant={isCompact ? 'h4' : 'h3'}
        fontWeight={800}
        lineHeight={1}
        color={priceColor}
      >
        ${amount}
      </Typography>

      <Typography
        variant={isCompact ? 'body4' : 'body3'}
        fontWeight={500}
        lineHeight={1}
        color={periodColor}
      >
        / {periodLabel}
      </Typography>
    </Stack>
  );
});

PlanPrice.displayName = 'PlanPrice';
